import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwTextareaField";

/**
 * VuwHtmlField (extends VuwTextareaField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {String} placeholder
 * - {Boolean} autosize
 */
vuwer.appendKlass("VuwHtmlField", {
	inpType: "html",
	inpClassList: ["inp"],
	
	_getCopiedInp: function _getCopiedInp(val) {
		const clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if( u_.isString(val) && val ) {
			clones.push( $("<div/>") );
			clones[0].addClass("replaced-inp").html( $.parseHTML(val) );
			clones[0].find("a").attr("target", "_blank");
		}
		
		return clones;
	},
	
	_renderField: function _renderField() {
		return Klass("VuwHtmlField").parent._renderField.call(this).addClass("field-html");
	}
}, "VuwTextareaField");
